import { Box, Card } from "@mui/material";
import { CustomizedText } from "../../../components/styled-componnets";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface OpportunityOverviewCardProps {
	summary: string;
}

const OpportunityOverviewCard = ({ summary }: OpportunityOverviewCardProps) => {
	const formatSummaryText = (text: string) => {
		if (!text) return "";
		// Match text enclosed in double asterisks, e.g., **bold text**
		const parts = text.split(/(\*\*.*?\*\*)/g);
		return parts.map((part, index) => {
			if (part.startsWith("**") && part.endsWith("**")) {
				return (
					<strong key={index} style={{ fontWeight: 700, color: "#111827" }}>
						{part.slice(2, -2)}
					</strong>
				);
			}
			return part;
		});
	};

	return (
		<Card
			sx={{
				background: "#f0fdf6",
				borderRadius: "16px",
				border: "1.5px solid #bbf7d0",
				boxShadow: "0 4px 12px rgba(34, 197, 94, 0.05)",
				p: 3,
				mb: 2,
				mt: 2,
				width: "95%",
				display: "flex",
				flexDirection: "column",
				transition: "all 0.3s ease",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					width: "100%",
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
					<Box
						sx={{
							background: "#10b981",
							borderRadius: "50%",
							width: 36,
							height: 36,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexShrink: 0,
						}}
					>
						<AutoAwesomeIcon sx={{ color: "#fff", fontSize: 20 }} />
					</Box>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<CustomizedText fontSize={18} fontColor="#047857" font="Lora-Bold">
							Customer Insights
						</CustomizedText>
						<CustomizedText
							fontSize={14}
							fontColor="#059669"
							font="Lora-Regular"
							sx={{ fontStyle: "italic" }}
						>
							Know your buyer before you meet them
						</CustomizedText>
					</Box>
				</Box>
			</Box>

			<Box
				sx={{
					background: "#ffffff",
					border: "1px solid #d1fae5",
					borderRadius: "12px",
					p: 2.5,
					mt: 2.5,
				}}
			>
				<CustomizedText
					fontSize={16}
					fontColor="#374151"
					font="Lora-Regular"
					sx={{ lineHeight: 1.7 }}
				>
					{formatSummaryText(summary)}
				</CustomizedText>
				<CustomizedText
					fontSize={14}
					fontColor="maroon"
					font="Lato-Regular"
					sx={{ mt: 2, fontStyle: "italic", display: "block" }}
				>
					(Disclaimer: This is AI-generated content 🤖. Kindly refer to the customer profiling form for verified and accurate information.)
				</CustomizedText>
			</Box>
		</Card>
	);
};

export default OpportunityOverviewCard;
